export const setDomain = (domainMin: string, domainMax: string) => {
    const min = setValue(domainMin);
    const max = setValue(domainMax)
    return [min, max];
}

const setValue = (input: string) => {
    return checkForNumber(input) ? formatToNumber(input) : input;
}
const checkForNumber = (input: string) => {
    return parseInt(input) === NaN ? false : true
}
const formatToNumber = (input: any) => {
    const number = input * 1000;
    return parseInt(number.toString()) / 1000;
}


// WEBPACK FOOTER //
// ./src/components/AreaChart/utils/setDomain.ts